export enum UserActionType {
    PAGINATE_USERS = 'paginate_users',
    CREATE_USER = 'create_user',
    UPDATE_USER = 'update_user',
    DELETE_USER = 'delete_user'
}